import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import mergeByIds from '../../utils/mergeByIds';
import { mapValues, uniq } from 'lodash';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST_SUCCESS:
    case types.ADD_TEMPLATES_TO_CART_REQUEST_SUCCESS:
      return mergeByIds({
        byIdCurrent: state,
        byIdToMerge: payload.entities.modelState,
      });
    case types.REMOVE_TEMPLATE_FROM_WORKING_STATE: {
      const { modelId, templateId } = payload;
      const updatedState = { ...state };
      updatedState[modelId].templatesWorkingState = updatedState[
        modelId
      ].templatesWorkingState.filter(id => id !== templateId);
      return updatedState;
    }
    case types.ADD_TEMPLATE_TO_WORKING_STATE: {
      const { modelId, templateId, duplicateTemplateId } = payload;
      const updatedState = { ...state };
      let templatesWorkingState = updatedState[modelId].templatesWorkingState;
      let newTemplatesWorkingState;
      if (duplicateTemplateId) {
        const duplicateIdIndex = templatesWorkingState.indexOf(
          duplicateTemplateId,
        );
        newTemplatesWorkingState = [
          ...templatesWorkingState.slice(0, duplicateIdIndex + 1),
          templateId,
          ...templatesWorkingState.slice(duplicateIdIndex + 1),
        ];
      } else {
        newTemplatesWorkingState = templatesWorkingState.concat([templateId]);
      }
      updatedState[modelId].templatesWorkingState = newTemplatesWorkingState;
      return updatedState;
    }
    case types.SWAP_TEMPLATES: {
      const { oldTemplateId, newTemplateId } = payload;
      let newState = mapValues(state, value => {
        const oldTemplateIdIndex = value.templatesWorkingState.indexOf(
          oldTemplateId,
        );
        let templatesWorkingState = [
          ...value.templatesWorkingState.slice(0, oldTemplateIdIndex),
          newTemplateId,
          ...value.templatesWorkingState.slice(oldTemplateIdIndex + 1),
        ];

        templatesWorkingState = uniq(templatesWorkingState);
        return {
          ...value,
          templatesWorkingState,
        };
      });
      return newState;
    }
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
